import React from 'react';
import styles from './index.module.css';

import logo from '@/assets/images/globis_logo.svg';

export const PlainHeader = () => {
  return (
    <header className={styles.header}>
      <h1 className={styles.logo}>
        <img src={logo} alt="GLOBIS" />
      </h1>
    </header>
  );
};
